// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__glm3U","large":"styles_large__1EMRN"};